import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownExcursionServices', request)
}

async function post(request) {
    return await postMethod('/api/ownExcursionServices', request)
}

async function put(request) {
    return await putMethod('/api/ownExcursionServices', request)
}

export {get, post, put}
